import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    NumberField,
    ArrayField,
    Datagrid,
     } from 'react-admin';
import CustomURLField from './CustomURLField';

const CustomAmountField = ({ record }) => {
    if(record  && record.originAmount>0 && record.originAmount != record.amount){
        return (
            <div>
                <span style={{ color: 'red' }}>Actual Amount({record.currency}): {record.amount}</span><br/><br/>
                <span>Original Amount({record.currency}): {record.originAmount}</span><br/><br/>
            </div>
        );
    }
    return (
        <div>
            Amount ({record.currency}): {record.amount}<br/><br/>
        </div>
    ); 
};

const CustomVolumeField = ({ record }) => {
    if(record  && record.originVolume>0 && record.originVolume != record.volume){
        return (
            <div>
                <span style={{ color: 'red' }}>Actual Coin Amount: {record.btcVolStr}</span><br/><br/>
                <span>Original Coin Amount: {record.originBtcVolStr}</span><br/><br/>
            </div>
        );
    }
    return (
        <div>
            Coin Amount: {record.btcVolStr}<br/><br/>
        </div>
    );
};

export const TransactionShow = ({permissions, ...props}) => (
    <Show title=" " {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="transaction_id" label="Transaction ID" />
            {/* <ReferenceField label="Coin" source="coin_id" reference="coins" linkType="show">
                <TextField source="symbol" />
            </ReferenceField>
            <ReferenceField label="Location" source="location_id" reference="locations" linkType="show">
                <TextField source="nickName" />
            </ReferenceField> */}
            {/* <UrlField source="payMethod" /> */}
            <CustomAmountField source="amount" label={`Amount (${props.record.currency})`}  />
            <CustomVolumeField source="volume" label="Volume"  />
            {/* <DateField source="createdAt" showTime/> */}
            <CustomURLField source="chainTxHash"  />
            <TextField source="note"  />
            {permissions === "system_admin" ?
                <ArrayField source="systemLedgers" label="System Ledgers">
                    <Datagrid>
                        <TextField source="name" label="Name" />
                        <TextField source="type" label="Type" />
                        <NumberField source="amount" label="Amount" />
                        <TextField source="currency" label="Currency" />
                        <TextField source="source" label="Source" />
                    </Datagrid>
                </ArrayField>
            : null }
        </SimpleShowLayout>
    </Show>
);


export default TransactionShow;